export const environment = {
  production: false,
  apiUrl: 'https://eicapistage.cyberland.sg/api',
  LATEST_VERSION: '2.23.0',
};
